import { type Meta } from '../types/docs';
import { UPLOAD_ANALYTICS_COMMON_META_PARAMS } from './uploadAnalyticsMetaParams';

const META: Meta = {
  description: 'Upload began transferring or became ready to transfer',
  name: 'upload_started',
  params: [
    ...UPLOAD_ANALYTICS_COMMON_META_PARAMS,
    {
      description: 'Time from queue creation to upload start in milliseconds',
      name: 'queued_duration_ms',
      required: false,
      type: 'number',
    },
    {
      description: 'Retry attempt for this upload start. Initial transfer is 0.',
      name: 'retry_count',
      required: true,
      type: 'number',
    },
    {
      description: 'Maximum retry count configured for the upload transfer',
      name: 'max_retry_count',
      required: false,
      type: 'number',
    },
    {
      description: 'Why this upload transfer started',
      name: 'start_reason',
      required: true,
      type: 'enum',
      values: ['initial', 'retry'],
    },
    {
      description: 'Whether this event fired after upload URL creation',
      name: 'started_after_url_fetch',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Which presigned URL type the upload transfer used',
      name: 'upload_url_type',
      required: false,
      type: 'enum',
      values: ['primary', 'fallback'],
    },
  ],
};

export default META;
